
const user_data = `https://${process.env.REACT_APP_API_ID}.execute-api.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_STAGE}/user/data`
export const entra_app_id = process.env.REACT_APP_ENTRA_APP_ID
export const entra_authority = process.env.REACT_APP_ENTRA_AUTHORITY
const notification = `https://${process.env.REACT_APP_API_ID}.execute-api.${process.env.REACT_APP_REGION}.amazonaws.com/${process.env.REACT_APP_STAGE}/notification`

const region = process.env.REACT_APP_REGION
export {
    region,
    user_data,
    notification
}